import React from 'react';

import { CheckMarkCircle2 as IconCheckMarkCircle2 } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';
import { Image } from '@/components/Image';

import { avatarImage } from './style';

interface SingleAvatarProps {
  url: string;
  selectedAvatar: string;
  selectAvatar: (url: string) => void;
}

function SingleAvatar(props: SingleAvatarProps) {
  const { url, selectedAvatar, selectAvatar } = props;

  return (
    <Box
      className={cn(
        selectedAvatar === url ? 'selected' : '',
        'relative col-span-1 row-span-1 cursor-pointer rounded-full',
        avatarImage,
      )}
      onClick={() => selectAvatar(url)}>
      <Image
        alt={url}
        className={cn(
          'h-full w-full rounded-full xs:absolute xs:top-0 xs:bottom-0 xs:end-0 xs:start-0',
          selectedAvatar === url ? 'border-background border-2 border-solid' : '',
        )}
        layout="fill"
        src={url}
      />
      {selectedAvatar === url ? (
        <>
          <IconCheckMarkCircle2 className="selected-icon absolute z-20 h-24 w-24" />
          <Box className="icon-backdrop absolute z-10 h-16 w-16 rounded-full bg-bg-primary" />
        </>
      ) : null}
    </Box>
  );
}

export default React.memo(SingleAvatar);
